import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './header-breadcrumb.css';
import RoutingService from '../../services/RoutingService';

const RS = new RoutingService();

class HeaderBreadcrumb extends ComponentHelper {
	render() {
		return (
			<div className={`header-breadcrumb hbox vcenter ${this.props.className}`}>
				<div className="path" data-rh="Tenant" data-rh-at="bottom">
					{RS.getCurrentTenant()}
				</div>
				<i className="mdi mdi-chevron-right" />
				<div className="path env" data-rh="Environment" data-rh-at="bottom">
					{RS.getCurrentEnvironment()}
				</div>
				{RS.getCurrentApplication() && [
					<i className="mdi mdi-chevron-right" key="header-breadcrumb-app-chev" />,
					<div className="path" data-rh="Application" data-rh-at="bottom" key="header-breadcrumb-app-name">
						{RS.getCurrentApplication()}
					</div>
				]}
				{this.props.currentPage && [
					<i className="mdi mdi-chevron-right" key="bread-brumb-icon" />,
					<div className="page" key="breadcrumb-label">
						{this.props.currentPage}
					</div>
				]}
			</div>
		);
	}
}

export default HeaderBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/header-breadcrumb/HeaderBreadcrumb.js